module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Dashboard",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('CollapsibleCard', {
    attrs: {
      "title": "Filters",
      "visible": false
    }
  }, [_c('b-row', {
    staticClass: "p-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "name-group",
      "label": "Group:",
      "label-for": "group",
      "description": "Select the server group to display"
    }
  }, [(_vm.groupOptions !== null) ? _c('b-input-group', [_c('b-form-select', {
    attrs: {
      "placeholder": "Select Group",
      "options": _vm.groupOptions
    },
    on: {
      "input": function($event) {
        return _vm.loadServers()
      }
    },
    model: {
      value: (_vm.group),
      callback: function($$v) {
        _vm.group = $$v
      },
      expression: "group"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, _vm._l((_vm.servers), function(server) {
    return _c('span', [_c('span', {
      style: ('cursor:pointer; color:' + server.color)
    }, [_c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "title": server.visible ? 'Hide' : 'Show'
      },
      on: {
        "click": function($event) {
          return _vm.setVisible(server.id, !server.visible)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": server.visible ? 'eye' : 'eye-slash'
      }
    })], 1), _vm._v(" "), (server.visible) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.viewServerDashboard(server.id)
        }
      }
    }, [_vm._v(_vm._s(server.name))]) : _vm._e(), _vm._v(" "), (!server.visible) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.viewServerDashboard(server.id)
        }
      }
    }, [_c('strike', [_vm._v(_vm._s(server.name))]), _vm._v(" ")], 1) : _vm._e()])])
  }), 0)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    ref: "cpu"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("CPU")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    },
    on: {
      "click": function($event) {
        return _vm.fullscreenCpu()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "microchip",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.cpuChartData != null) ? _c('line-chart', {
    ref: "cpuChart",
    attrs: {
      "chartData": _vm.cpuChartData,
      "options": _vm.relativeOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Memory")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "memory",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.memoryChartData != null) ? _c('line-chart', {
    ref: "memoryChart",
    attrs: {
      "chartData": _vm.memoryChartData,
      "options": _vm.relativeOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Swap")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "memory",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.swapChartData != null) ? _c('line-chart', {
    ref: "swapChart",
    attrs: {
      "chartData": _vm.swapChartData,
      "options": _vm.relativeOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Disk")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "hdd",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.diskChartData != null) ? _c('line-chart', {
    ref: "diskChart",
    attrs: {
      "chartData": _vm.diskChartData,
      "options": _vm.relativeOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Disk Read")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "hdd",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.diskReadBytesChartData != null) ? _c('line-chart', {
    ref: "diskReadBytesChart",
    attrs: {
      "chartData": _vm.diskReadBytesChartData,
      "options": _vm.absoluteOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Disk Write")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "hdd",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.diskWriteBytesChartData != null) ? _c('line-chart', {
    ref: "diskWriteBytesChart",
    attrs: {
      "chartData": _vm.diskWriteBytesChartData,
      "options": _vm.absoluteOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Network Received")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "network-wired",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.networkReceivedBytesChartData != null) ? _c('line-chart', {
    ref: "networkReceivedBytesChart",
    attrs: {
      "chartData": _vm.networkReceivedBytesChartData,
      "options": _vm.absoluteOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Network Sent")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "network-wired",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.networkSentBytesChartData != null) ? _c('line-chart', {
    ref: "networkSentBytesChart",
    attrs: {
      "chartData": _vm.networkSentBytesChartData,
      "options": _vm.absoluteOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e52d6c2a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/ClassicDashboardPage.vue
// module id = 2150
// module chunks = 1